export default class OliveOil
{
  constructor(names = {}, descriptions = {}, consumptions = {}, temperatures = {}, castes = {}, stages = {}, datasheets = {}, photo = {}, position = 0) 
  {
    this.names = names;
    this.descriptions = descriptions;
    this.consumptions = consumptions;
    this.temperatures = temperatures;
    this.castes = castes;
    this.stages = stages;
    this.datasheets = datasheets;
    this.photo = photo;
    this.position = position;
  }
     

  isValid() {
    var result = true;
    
    if (!this.names || !Object.keys(this.names).length) result = false;
    if(result && (!this.descriptions || !Object.keys(this.descriptions).length)) result = false;
    if(result && (!this.consumptions || !Object.keys(this.consumptions).length)) result = false;
    if(result && (!this.temperatures || !Object.keys(this.temperatures).length)) result = false;
    if(result && (!this.castes || !Object.keys(this.castes).length)) result = false;
    if(result && (!this.stages || !Object.keys(this.stages).length)) result = false;
    if(result && (!this.photo || !Object.keys(this.photo).length)) result = false;
    if(result && !this.position) result = false;
  
    return result;
  }
  
}